<div class="guestView d-flex flex-fill">
    <div class="d-flex flex-fill flex-column">
        <sk-wave [isRunning]="IsSubmitting"></sk-wave>

        <div class="highlightHeader" *ngIf="Model && !IsSubmitting">
            <div class="d-flex justify-content-between">
                <div *ngIf="Model.CountryCode">
                    <img src="{{'Images/CountryFlags/' + (Model.CountryCode | lowercase) + '.png'}}"
                         class="img-fluid" />
                </div>
                <div *ngIf="!Model.CountryCode">&nbsp;</div>
                <div>
                    <span *ngIf="Model.UpcomingReservation">
                        {{Model.UpcomingReservation.LocationDescription}}
                        -
                    </span>&nbsp;{{Model.Description}}
                </div>
                <div>&nbsp;</div>
            </div>
        </div>

        <div *ngIf="Model && !IsSubmitting && !isVisitor"
             class="media border-bottom px-4 pt-4 bg-white">
            <div class="guestImageContainer">
                <div>
                    <img src='{{AppSettings.GuestImageURL + "?GuestId=" + Model.GuestId + "&" + guid}}'
                         class="imgGuest img-fluid" />
                </div>
                <div class="text-center text-primary pb-3 pt-2">
                    <a class=""
                       *ngIf="CheckAuth_Dept_Action(Model.PropertyId, 0, _AuthActionCodes.FrontOffice) && CheckAuth_Dept_Action(Model.PropertyId, 0, _AuthActionCodes.GuestImage)"
                       (click)="onUploadImage()"
                       translate>LBL.CHANGE_IMAGE</a>
                </div>
            </div>
            <div class="media-body ml-3">
                <div class="row">
                    <div class="col">
                        <div class="row subSection"
                             *ngIf="Model.UpcomingReservation">
                            <div class="col-auto d-flex align-items-center"
                                 title="{{'TITLE.TITLE_ARRIVAL_DATE' | translate}} & {{'TITLE.TITLE_DEPARTURE_DATE' | translate}}">
                                <i class="fas fa-calendar-alt fa-fw"></i>
                                <div class="mr-2">
                                    &nbsp;{{
Model.UpcomingReservation.ArrivalDate
                                    | amDateFormat:DateFormat
                                    }}
                                </div>
                                <div class="mr-2">
                                    <i class="fas fa-arrow-right"></i>
                                </div>
                                <div>
                                    {{
Model.UpcomingReservation.DepartureDate |
                                    amDateFormat:DateFormat
                                    }}
                                </div>
                            </div>
                        </div>

                        <div class="row subSection border-bottom-0">
                            <div class="col-auto"
                                 *ngIf="Model.UpcomingReservation && (Model.UpcomingReservation.Adult || Model.UpcomingReservation.Children)">
                                <div class="lblDisplay" translate>LBL.PAX</div>
                                <div>
                                    <span *ngIf="Model.UpcomingReservation.Adult">
                                        {{Model.UpcomingReservation.Adult}}
                                        <span translate>LBL.ADULTS</span>
                                    </span>
                                    <span *ngIf="Model.UpcomingReservation.Children">
                                        + {{Model.UpcomingReservation.Children}}
                                        <span translate>LBL.CHILDREN</span>
                                    </span>
                                </div>
                            </div>
                            <div class="col-auto" *ngIf="Model.Vip">
                                <div class="lblDisplay" translate>
                                    LBL.VIP_LEVEL
                                </div>
                                {{Model.Vip}}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row no-gutters" *ngIf="Model && !IsSubmitting">
            <div class="col">
                <ul class="sectionNav list-unstyled d-flex justify-content-around">
                    <li *ngIf="CheckAuth_Dept_Action(Model.PropertyId, 0, _AuthActionCodes.GuestReservation_Info) && !isVisitor"
                        class="col text-center tabbar-icon flex-column"
                        (click)="ChangeNav(1)"
                        [ngClass]="{'selected': SelectedNav == 1}"
                        title='{{"LBL.RESERVATION_DETAIL" | translate}}'>
                        <img class="svg-icon" src="/Images/UFIcons/PMS.svg"/>
                        <div class="small" translate>LBL.RESERVATION</div>
                    </li>
                    <li *ngIf="CheckAuth_Dept_Action(Model.PropertyId, 0, _AuthActionCodes.GuestProfile_Info) && !isVisitor"
                        class="col text-center"
                        (click)="ChangeNav(2)"
                        [ngClass]="{'selected': SelectedNav == 2}"
                        title='{{"LBL.GUEST_INFO" | translate}}'>
                        <i class="fa-2x icon-kc-icon_guest"></i>
                        <div class="small" translate>LBL.INFO</div>
                    </li>
                    <li *ngIf="masterService.CheckActiveLicence_Module(masterService.ActivePropertyID, 'TTN_RRESP') && GetDepartments_Action(Model.PropertyId, _AuthActionCodes.CallConsoleView).length > 0 && CheckAuth_Dept_Action(Model.PropertyId, 0, _AuthActionCodes.GuestHistory_KSV_KG) && !isVisitor"
                        class="col text-center tabbar-icon flex-column"
                        (click)="ChangeNav(3)"
                        [ngClass]="{'selected': SelectedNav == 3}"
                        title='{{"LBL.JOBS" | translate}}'>
                        <img class="svg-icon" src="/Images/UFIcons/Service.svg"/>
                        <div class="small" translate>LBL.JOBS</div>
                    </li>
                    <li *ngIf="masterService.CheckActiveLicence_Module(masterService.ActivePropertyID, 'TTN_GLIT') && GetDepartments_Action(Model.PropertyId, _AuthActionCodes.GlitchView).length > 0 && CheckAuth_Dept_Action(Model.PropertyId, 0, _AuthActionCodes.GuestHistory_KSV_KG)"
                        class="col text-center tabbar-icon flex-column"
                        (click)="ChangeNav(4)"
                        [ngClass]="{'selected': SelectedNav == 4}"
                        title='{{"LBL.GLITCHES" | translate}}'>
                        <img class="svg-icon" src="/Images/UFIcons/Glitch.svg"/>
                        <div class="small" translate>LBL.GLITCHES</div>
                    </li>
                    <!--<li (click)="ChangeNav(3)" [ngClass]="{'selected': SelectedNav == 3}"><span translate>LBL.GUEST_PREF</span></li>
                    <li (click)="ChangeNav(4)" [ngClass]="{'selected': SelectedNav == 4}"><span translate>LBL.ADDRESS</span></li>
                    <li (click)="ChangeNav(5)" [ngClass]="{'selected': SelectedNav == 5}"><span translate>LBL.CONTACT_INFO</span></li>
                    <li (click)="ChangeNav(6)" [ngClass]="{'selected': SelectedNav == 6}"><span translate>LBL.MEMBERSHIP</span></li>
                    <li class="mb-5" (click)="ChangeNav(7)" [ngClass]="{'selected': SelectedNav == 7}"><span translate>LBL.NOTES</span></li>-->
                </ul>
            </div>
        </div>

        <div class="guestContent d-flex flex-fill">
            <div class=" flex-fill section-scroll">
                <div *ngIf="Model && !IsSubmitting && SelectedNav == 1">
                    <table class="table table-sm reservDetails"
                           *ngIf="Model.UpcomingReservation && CheckAuth_Dept_Action(Model.PropertyId, 0, _AuthActionCodes.GuestReservation_Info)">
                        <tbody>
                            <tr>
                                <td class="lblDisplay tblLabelWidth p-2 pl-3">
                                    <span translate>LBL.CONFIRMATION_NO</span>
                                </td>
                                <td>
                                    {{Model.UpcomingReservation.ConfirmationId}}
                                </td>
                            </tr>
                            <tr>
                                <td class="lblDisplay tblLabelWidth p-2 pl-3">
                                    <span translate>LBL.PMS_RESERV_ID</span>
                                </td>
                                <td>
                                    {{Model.UpcomingReservation.PmsReservationId}}
                                </td>
                            </tr>
                            <tr>
                                <td class="lblDisplay tblLabelWidth p-2 pl-3">
                                    <span translate>LBL.RESERVATION_STATUS</span>
                                </td>
                                <td>
                                    <span translate>{{'MASTER.MASTER_RESERVATION_STATUS_'+Model.UpcomingReservation.ReservationStatus}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="lblDisplay tblLabelWidth p-2 pl-3">
                                    <span translate>LBL.ROOM_TYPE</span>
                                </td>
                                <td>{{Model.UpcomingReservation.RoomType}}</td>
                            </tr>
                            <tr>
                                <td class="lblDisplay tblLabelWidth p-2 pl-3">
                                    <span translate>LBL.ROOM_RATE</span>
                                </td>
                                <td>
                                    {{Model.UpcomingReservation.RateAmount}}
                                </td>
                            </tr>
                            <tr>
                                <td class="lblDisplay tblLabelWidth p-2 pl-3">
                                    <span translate>LBL.SHARER_NAME</span>
                                </td>
                                <td>{{Model.UpcomingReservation.Sharer}}</td>
                            </tr>
                            <ng-container *ngIf="Model.UpcomingReservation.ReservationExtendedData && Model.UpcomingReservation.ReservationExtendedData.length > 0">
                                <tr *ngFor="let row of Model.UpcomingReservation.ReservationExtendedData">
                                    <td class="lblDisplay tblLabelWidth p-2 pl-3">
                                        {{row.DataKey | translate}}
                                    </td>
                                    <td>{{row.DataValue}}</td>
                                </tr>
                            </ng-container>

                            <!--<tr >
                                <td class="lblDisplay tblLabelWidth p-2 pl-3"><span translate>LBL.NO_OF_STAYS</span></td>
                                <td>{{Model.UpcomingReservation.NoOfStays}}</td>
                            </tr>-->
                            <!--<tr>
                                <td class="lblDisplay tblLabelWidth p-2 pl-3"><span translate>LBL.RESERVATION_SPECIALS</span></td>
                                <td>{{Model.UpcomingReservation.SpecialRequests}}</td>
                            </tr>-->
                            <tr *ngIf="Model.UpcomingReservation.SpecialRequests != '' && SpecialRequests.length > 0">
                                <td class="p-0" colspan="2">
                                    <table class="table mb-0">
                                        <tr>
                                            <td class="lblDisplay p-2 pl-3 tab_header"
                                                colspan="3">
                                                <span translate>LBL.RESERVATION_SPECIALS</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="lblDisplay p-2 pl-3">
                                                <span translate>LBL.CODE</span>
                                            </td>
                                            <td class="lblDisplay p-2 pl-3">
                                                <span translate>LBL.TYPE</span>
                                            </td>
                                            <td class="lblDisplay p-2 pl-3">
                                                <span translate>LBL.DESCR</span>
                                            </td>
                                        </tr>
                                        <tr *ngFor="let row of SpecialRequests">
                                            <td class="p-2 pl-3">
                                                {{row.Code}}
                                            </td>
                                            <td class="p-2 pl-3">
                                                {{row.PrefType}}
                                            </td>
                                            <td class="p-2 pl-3">
                                                {{row.Descr}}
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr *ngIf="Model.UpcomingReservation.ReservationComments">
                                <td class="lblDisplay p-2 pl-3 tab_header"
                                    colspan="2">
                                    <span translate>LBL.RESERVATION_COMMENT</span>
                                </td>
                            </tr>
                            <tr *ngIf="Model.UpcomingReservation.ReservationComments">
                                <td colspan="2" class="linebreak p-2 pl-3">
                                    {{Model.UpcomingReservation.ReservationComments}}
                                </td>
                            </tr>
                            <tr>
                                <td class="lblDisplay tab_header p-2 pl-3"
                                    colspan="2">
                                    <span translate>LBL.BOOKING_DETAILS</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="lblDisplay tblLabelWidth p-2 pl-3">
                                    <span translate>LBL.SOURCE</span>
                                </td>
                                <td>{{Model.UpcomingReservation.Source}}</td>
                            </tr>
                            <tr>
                                <td class="lblDisplay tblLabelWidth p-2 pl-3">
                                    <span translate>LBL.BOOKING</span>
                                </td>
                                <td>{{Model.UpcomingReservation.Booking}}</td>
                            </tr>
                            <tr>
                                <td class="lblDisplay tblLabelWidth p-2 pl-3">
                                    <span translate>LBL.GROUP_NAME</span>
                                </td>
                                <td>{{Model.UpcomingReservation.GroupName}}</td>
                            </tr>
                        </tbody>
                    </table>

                    <table *ngIf="AccompanyingGuestIds && AccompanyingGuestIds.length" class="table table-sm reservDetails">
                        <tr>
                            <td class="lblDisplay p-2 pl-3 tab_header">
                                <div class="d-flex align-items-center">
                                    <span translate class="mr-auto">LBL.LBL_ACCOMPANY_GUESTS</span>
                                    <ng-container *ngIf="IsAccompanyingGuestsLoading">
                                        <sk-wave [isRunning]="IsAccompanyingGuestsLoading"></sk-wave>
                                    </ng-container>
                                </div>
                            </td>
                        </tr>
                        <ng-container *ngIf="AccompanyingGuests && AccompanyingGuests.length">
                            <tr *ngFor="let guest of AccompanyingGuests">
                                <td class="p-1 pl-3">
                                    {{ guest.Description }}
                                </td>
                            </tr>
                        </ng-container>

                    </table>

                    <table class="table table-sm reservDetails">
                        <tr>
                            <td class="lblDisplay p-2 pl-3 tab_header" colspan="3">
                                <div class="d-flex align-items-center">
                                    <span translate class="mr-auto">LBL.LBL_TRACES</span>

                                    <div *ngIf="ReservationTraces && ReservationTraces.length > 0 && lstTraceDepartments.length > 1" class="d-flex align-items-center">
                                        <ng-select [items]="lstTraceDepartments"
                                                   placeholder="{{'PH.PH_SELECT_DEPT' | translate}}"
                                                   (change)="onTraceDeptChange($event);"
                                                   style="width: 160px;"
                                                   [(ngModel)]="SelectedTraceDepartment">
                                        </ng-select>


                                        <div class="ml-3" *ngIf="ReservationTracesFiltered.length > TracesPaginationModel.pageSize">
                                            <ngb-pagination [collectionSize]="ReservationTracesFiltered.length"
                                                            [pageSize]="TracesPaginationModel.pageSize"
                                                            [(page)]="TracesPaginationModel.page"
                                                            [boundaryLinks]="true">
                                            </ngb-pagination>
                                        </div>
                                    </div>
                                </div>
                            </td>
                        </tr>

                        <tr *ngIf="IsTracesLoading">
                            <td colspan="3">
                                <sk-wave [isRunning]="IsTracesLoading"></sk-wave>
                            </td>
                        </tr>

                        <tr *ngIf="!IsTracesLoading && !ReservationTraces?.length">
                            <td colspan="3" class="linebreak p-2 pl-3">
                                <span translate>LBL.LBL_NO_TRACES</span>
                            </td>
                        </tr>

                        <ng-container *ngIf="ReservationTraces && ReservationTraces.length">
                            <tr>
                                <td class="lblDisplay p-2 pl-3">
                                    <span translate>LBL.TEXT_DATE</span>
                                </td>
                                <td class="lblDisplay p-2 pl-3">
                                    <span translate>ENTITIES.ENTITIES_DEPT</span>
                                </td>
                                <td class="lblDisplay p-2 pl-3">
                                    <span translate>LBL.DESCR</span>
                                </td>
                            </tr>

                            <tr *ngFor="let row of ReservationTracesFiltered | slice: (TracesPaginationModel.page-1) * TracesPaginationModel.pageSize : (TracesPaginationModel.page -1) * TracesPaginationModel.pageSize + TracesPaginationModel.pageSize; trackBy: trackTraceByUUID">
                                <td class="p-2 pl-3">
                                    {{row.TraceDate | amFromUtc | amDateFormat: OnlyDateFormat}}
                                </td>
                                <td class="p-2 pl-3">
                                    {{row.TraceDepartment}}
                                </td>
                                <td class="p-2 pl-3">
                                    {{row.TraceText}}
                                </td>
                            </tr>
                        </ng-container>

                    </table>
                </div>

                <div *ngIf="Model && !IsSubmitting && SelectedNav == 2 && CheckAuth_Dept_Action(Model.PropertyId, 0, _AuthActionCodes.GuestProfile_Info)">
                    <table class="table table-sm reservDetails">
                        <tbody>
                            <tr>
                                <td class="lblDisplay tblLabelWidth p-2 pl-3">
                                    <span translate>LBL.PMS_PROFILE_ID</span>
                                </td>
                                <td>{{Model.PmsId}}</td>
                            </tr>
                            <tr>
                                <td class="lblDisplay tblLabelWidth p-2 pl-3">
                                    <span translate>LBL.BIRTH_DATE</span>
                                </td>
                                <td>{{Model.BirthDay}}</td>
                            </tr>
                            <tr>
                                <td class="lblDisplay tblLabelWidth p-2 pl-3">
                                    <span translate>LBL.BUSINESS_TITLE</span>
                                </td>
                                <td>
                                    <span *ngIf="Model.UpcomingReservation">{{Model.UpcomingReservation.BusinessTitle}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="lblDisplay tblLabelWidth p-2 pl-3">
                                    <span translate>LBL.COMP_NAME</span>
                                </td>
                                <td>
                                    <span *ngIf="Model.UpcomingReservation">{{Model.UpcomingReservation.CompanyName}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="lblDisplay tblLabelWidth p-2 pl-3">
                                    <span translate>LBL.LANGUAGE</span>
                                </td>
                                <td>
                                    <span *ngIf="Model.UpcomingReservation">{{Model.UpcomingReservation.LanguageDescription}}</span>
                                </td>
                            </tr>
                            <tr>
                                <td class="lblDisplay tblLabelWidth p-2 pl-3">
                                    <span translate>LBL.GENDER</span>
                                </td>
                                <td>
                                    <div [ngSwitch]="Model.Gender">
                                        <span *ngSwitchCase="'M'" translate>LBL.MALE</span>
                                        <span *ngSwitchCase="'F'" translate>LBL.FEMALE</span>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td class="lblDisplay tblLabelWidth p-2 pl-3">
                                    <span translate>LBL.LAST_STAY</span>
                                </td>
                                <td>
                                    <span *ngIf="Model">
                                        {{
                                            Model.LastStayFrom | amDateFormat:DateFormat
                                        }} -
                                        {{
                                            Model.LastStayTo | amDateFormat:DateFormat
                                        }}
                                    </span>
                                </td>
                            </tr>
                            <tr *ngIf="Model.GuestPreferences && Model.GuestPreferences.length > 0">
                                <td class="p-0" colspan="2">
                                    <table class="table mb-0">
                                        <tr>
                                            <td class="lblDisplay p-2 pl-3 tab_header"
                                                colspan="4">
                                                <span translate>LBL.GUEST_PREF</span>
                                            </td>
                                        </tr>
                                        <tr *ngFor="let row of Model.GuestPreferences">
                                            <td class="p-2 pl-3">
                                                {{row.SystemId}}
                                            </td>
                                            <td class="p-2 pl-3">
                                                {{row.Code}}
                                            </td>
                                            <td class="p-2 pl-3 ">
                                                <a *ngIf="IsSystemGuestPreference(row)"
                                                   href="javascript:{}"
                                                   (click)="OpenCallRegister(row)">{{row.CallDescription}}</a>
                                                <span *ngIf="!IsSystemGuestPreference(row)">{{row.CallDescription}}</span>
                                                <a *ngIf="row.CallDescription == null"
                                                   href="javascript:{}">{{row.CallDescription}}</a>
                                            </td>
                                            <td class="p-2 pl-3 text-right"
                                                *ngIf="CheckAuth_Dept_Action(Model.PropertyId, 0, _AuthActionCodes.DeleteGuestPreference)">
                                                <button *ngIf="row.CallDescription && IsSystemGuestPreference(row)"
                                                        class="btn btn-link p-0"
                                                        (click)="deleteObject.Open(row.CallDescription, row)"
                                                        title="Delete">
                                                    <i class="fas fa-trash-alt"></i>
                                                </button>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>

                            <tr *ngIf="Model.GuestAddresses && Model.GuestAddresses.length > 0">
                                <td class="p-0" colspan="2">
                                    <table class="table mb-0">
                                        <tr>
                                            <td class="lblDisplay  p-2 pl-3 tab_header"
                                                colspan="7">
                                                <span translate>LBL.ADDRESS</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="lblDisplay p-2 pl-3">
                                                <span translate>LBL.TYPE</span>
                                            </td>
                                            <td class="lblDisplay p-2 pl-3">
                                                <span translate>LBL.ADDRESS</span>
                                            </td>
                                            <td class="lblDisplay p-2 pl-3">
                                                <span translate>LBL.CITY</span>
                                            </td>
                                            <td class="lblDisplay p-2 pl-3">
                                                <span translate>LBL.STATE</span>
                                            </td>
                                            <td class="lblDisplay p-2 pl-3">
                                                <span translate>LBL.COUNTRY</span>
                                            </td>
                                            <td class="lblDisplay p-2 pl-3">
                                                <span translate>LBL.PIN_CODE</span>
                                            </td>
                                            <td class="lblDisplay p-2 pl-3">
                                                <span translate>LBL.PRIMARY</span>
                                            </td>
                                        </tr>
                                        <tr *ngFor="let row of Model.GuestAddresses">
                                            <td class="p-2 pl-3">
                                                <div [ngSwitch]="row.Type">
                                                    <span *ngSwitchCase="'H'"
                                                          translate>LBL.HOME</span>
                                                    <span *ngSwitchCase="'HOME'"
                                                          translate>LBL.HOME</span>
                                                    <span *ngSwitchCase="'B'"
                                                          translate>LBL.BUSINESS</span>
                                                    <span *ngSwitchCase="'BUS'"
                                                          translate>LBL.BUSINESS</span>
                                                    <span *ngSwitchCase="'BUSINESS'"
                                                          translate>LBL.BUSINESS</span>
                                                </div>
                                            </td>
                                            <td class="p-2 pl-3">
                                                {{row.Address1}}
                                            </td>
                                            <td class="p-2 pl-3">
                                                {{row.City}}
                                            </td>
                                            <td class="p-2 pl-3">
                                                {{row.State}}
                                            </td>
                                            <td class="p-2 pl-3">
                                                {{row.CountryName}}
                                            </td>
                                            <td class="p-2 pl-3">
                                                {{row.Postalcode}}
                                            </td>
                                            <td class="p-2 pl-3">
                                                <i [hidden]="!row.IsPrimary"
                                                   class="fas fa-check"></i>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr *ngIf="Model.GuestContacts && Model.GuestContacts.length > 0">
                                <td class="p-0" colspan="2">
                                    <table class="table mb-0">
                                        <tr>
                                            <td class="lblDisplay p-2 pl-3 tab_header"
                                                colspan="3">
                                                <span translate>LBL.CONTACT_INFO</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="lblDisplay p-2 pl-3">
                                                <span translate>LBL.TYPE</span>
                                            </td>
                                            <td class="lblDisplay p-2 pl-3">
                                                <span translate>LBL.NUMBER</span>
                                            </td>
                                            <td class="lblDisplay p-2 pl-3">
                                                <span translate>LBL.PRIMARY</span>
                                            </td>
                                        </tr>
                                        <tr *ngFor="let row of Model.GuestContacts">
                                            <td class="p-2 pl-3">
                                                {{row.Type}}
                                            </td>
                                            <td class="p-2 pl-3">
                                                {{row.Contact}}
                                            </td>
                                            <td class="p-2 pl-3">
                                                <i [hidden]="!row.IsPrimary"
                                                   class="fas fa-check"></i>
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr *ngIf="Model.GuestMemberShips && Model.GuestMemberShips.length > 0">
                                <td class="p-0" colspan="2">
                                    <table class="table mb-0">
                                        <tr>
                                            <td class="lblDisplay p-2 pl-3 tab_header"
                                                colspan="4">
                                                <span translate>LBL.MEMBERSHIP</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="lblDisplay p-2 pl-3">
                                                <span translate>LBL.TYPE</span>
                                            </td>
                                            <td class="lblDisplay p-2 pl-3">
                                                <span translate>LBL.MEMBERSHIP_NO</span>
                                            </td>
                                            <td class="lblDisplay p-2 pl-3">
                                                <span translate>LBL.LEVEL</span>
                                            </td>
                                            <td class="lblDisplay p-2 pl-3">
                                                <span translate>LBL.EXPIRY_DATE</span>
                                            </td>
                                        </tr>
                                        <tr *ngFor="let row of Model.GuestMemberShips">
                                            <td class="p-2 pl-3">
                                                {{row.Type}}
                                            </td>
                                            <td class="p-2 pl-3">
                                                {{row.LoyaltyCardNo}}
                                            </td>
                                            <td class="p-2 pl-3">
                                                {{row.Level}}
                                            </td>
                                            <td class="p-2 pl-3">
                                                {{
row.ExpiryDate |
                                                amDateFormat:DateFormat
                                                }}
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                            <tr *ngIf="Model.GuestComments && Model.GuestComments.length > 0">
                                <td class="p-0" colspan="2">
                                    <table class="table mb-0">
                                        <tr>
                                            <td class="lblDisplay p-2 pl-3 tab_header"
                                                colspan="2">
                                                <span translate>LBL.NOTES</span>
                                            </td>
                                        </tr>
                                        <tr>
                                            <td class="lblDisplay p-2 pl-3">
                                                <span translate>LBL.TYPE</span>
                                            </td>
                                            <td class="lblDisplay p-2 pl-3">
                                                <span translate>LBL.REMARK</span>
                                            </td>
                                        </tr>
                                        <tr *ngFor="let row of Model.GuestComments">
                                            <td class="p-2 pl-3">
                                                {{row.CommentType}}
                                            </td>
                                            <td class="linebreak p-2 pl-3">
                                                {{row.Remarks}}
                                            </td>
                                        </tr>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <div [hidden]="SelectedNav != 3">
                    <JobConsole_Compact #jobConsole_Compact
                                        [Mode]="_JobSearch_Compact_Mode.Guest"></JobConsole_Compact>
                </div>
                <div [hidden]="SelectedNav != 4">
                    <GlitchConsole_Compact #glitchConsole_Compact></GlitchConsole_Compact>
                </div>
            </div>
        </div>
    </div>
</div>

<DeleteObject #deleteObject
              (ObjectDeleted)="DeletePreference($event)"></DeleteObject>
<UploadImage #uploadImage></UploadImage>
